import axios from '@_system/axios/axios.js'
export default {
	path: '/crmcustomer',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listDetail(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listDetail/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/crmcustomer.crmcustomer', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	distribution(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/distribution', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	extractAddress(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/extractAddress', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	listerpcustomer(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listerpcustomer', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	saveerpcustomer(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveerpcustomer', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	regionmatch(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/regionmatch', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	pull(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/pull', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	initCity(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/initCity', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},
	export (data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}